module.exports = __webpack_public_path__ + "img/[爱心].a38927bd.svg";